import { render, staticRenderFns } from "./paCodiceFiscale.vue?vue&type=template&id=1cbcec4e"
import script from "./paCodiceFiscale.vue?vue&type=script&lang=js"
export * from "./paCodiceFiscale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports